<template>
  <div class="col-3 contact-about d-flex flex-column" v-if="contact">
    <div class="contact-about col p-0" v-if="about.firstName">
      <div class="about-head">
        ข้อมูลผู้ติดต่อ
      </div>
      <div class="about-box">
        <div class="title">
          ชื่อผู้ติดต่อ
        </div>
        <div class="detail">{{ about.firstName }} {{ about.lastName }}</div>
      </div>
      <div class="about-box">
        <div class="title">
          บ้านเลขที่
        </div>
        <div class="detail">
          {{ about.address || "ไม่ระบุ" }}
        </div>
      </div>
      <div class="about-box">
        <div class="title">
          โครงการ
        </div>
        <div class="detail">
          {{ about.projectName || "ไม่ระบุ" }}
        </div>
      </div>
      <div class="about-box">
        <div class="title">
          สถานะการรับประกัน
        </div>
        <div class="detail">
          {{ about.homeWarrantyStatus || "ไม่ระบุ" }}
        </div>
        <div v-if="about.insuranceStart && about.insuranceEnd">
          {{ about.insuranceStart }} - {{ about.insuranceEnd }}
        </div>
      </div>
      <div class="about-box">
        <div class="title">
          สถานะ
        </div>
        <div class="detail">
          <span v-if="about.userRole === 'OWNER'">
            ผู้ถือกรรมสิทธิ์
          </span>
          <span v-else-if="about.userRole === 'RENTER'">
            ผู้เช่า
          </span>
          <span v-else-if="about.userRole === 'RESIDENT'">
            ผู้อาศัย
          </span>
          <span v-else>
            ไม่ระบุ
          </span>
        </div>
      </div>
      <div class="about-box">
        <div class="title">
          การติดต่อ
        </div>
        <div class="detail">
          {{ about.mobileNumber || "ไม่พบเบอร์โทรศัพท์," }}<br />
          {{ about.email || "ไม่พบอีเมล" }}
        </div>
      </div>
      <div class="about-box">
        <div class="title">
          History
        </div>
        <div
          class="List"
          v-for="(history, index) in about.histories"
          :key="index"
        >
          <router-link
            :to="{ name: 'Contact', params: { contactId: history.contactId } }"
            active-class="active"
          >
            {{
              history.contactCategory && history.contactCategory.title
                ? history.contactCategory.title
                : ""
            }}
            {{ history.contactId | contact_id }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    contact: Object
  },
  data() {
    return {
      about: {}
    };
  },
  methods: {
    getAbout() {
      const vm = this;
      axios
        .get(
          `${process.env.HOST}/admin/conversations/${this.contactId}/user/${
            this.userId
          }/home/${this.homeId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`
            }
          }
        )
        .then(res => {
          vm.about = res.data;
        })
        .catch(e => {
          throw e;
        });
    }
  },
  computed: {
    contactId() {
      return this.contact.contactId;
    },
    homeId() {
      return this.contact.homeId ? this.contact.homeId : "OTHER";
    },
    userId() {
      return this.contact.userId;
    }
  },
  watch: {
    contact() {
      this.getAbout();
    }
  }
};
</script>

<style scoped>
.contact-about {
  overflow-y: auto;
}
.about-head {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: #000000;
  padding-left: 15px;
  padding-top: 21px;
  padding-bottom: 21px;
  margin-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
}
.about-box {
  padding-left: 15px;
  padding-bottom: 20px;
}
.about-box .title {
  font-size: 11px;
  font-weight: 500;
  line-height: 1.64;
  color: #616161;
}
.about-box .detail {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.63;
  color: #4a4a4a;
}
.about-box .List {
  font-size: 16px;
  font-weight: 500;
  color: #4a4a4a;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/contact/ContactAbout.vue